import React, { useState } from "react";
import ReactTable from "../../components/constantComponent/reactTable/ReactTable";
import { Panel, PanelBody } from "./../../components/panel/panel.jsx";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { ApiKey, ApiUrl, LanguageKey } from "../../util/Constant";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { fetch } from "whatwg-fetch";
import { setBusy, setIdle, showMessage } from "../../redux/AppAction";
import { useDispatch } from "react-redux";

/// <summary>
/// Author : -
/// </summary>

const ProcessGameRecordReport = (props) => {
    const _dispatch = useDispatch();
    const { t } = useTranslation(LanguageKey._PRIMARY);
    const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [processReportDatas, setProcessReportDatas] = useState([]);
    /// <summary>
    /// Author : -
    /// </summary>
    useEffect(() => {
        getProcessReport();
    }, []);

    /// <summary>
    /// Author : -
    /// </summary>
    const getProcessReport = async () => {
        _dispatch(setBusy());
        let apiUrl = ApiUrl._API_GET_PROCESS_GAME_RECORD_REPORT + "?startDate=" + startDate + "&endDate=" + endDate;
        //setGetReportApi(apiUrl);
        await fetch(
            ApiUrl._API_GET_PROCESS_GAME_RECORD_REPORT +
            "?startDate=" +
            startDate +
            "&endDate=" +
            endDate,
            {
                method: ApiKey._API_GET,
                headers: {
                    "Content-Type": ApiKey._API_FORM_URLENCODED,
                    "X-Requested-With": ApiKey._API_XML_HTTP_REQUEST_KEY,
                },
            }
        )
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson[ApiKey._API_SUCCESS_KEY]) {
                    console.log(responseJson[ApiKey._API_DATA_KEY]);
                    setProcessReportDatas(responseJson[ApiKey._API_DATA_KEY]);
                } else {
                    _dispatch(
                        showMessage(
                            responseJson[ApiKey._API_SUCCESS_KEY],
                            t(responseJson[ApiKey._API_MESSAGE_KEY])
                        )
                    );
                }
                _dispatch(setIdle());
            });
    };

    let _tableColumns = [
        {
            Header: t("Id"),
            accessor: "id",
        },
        {
            Header: t("GameId"),
            accessor: "gameId",
        },
        {
            Header: t("BetId"),
            accessor: "betId",
        },
        {
            Header: t("MemberProductId"),
            accessor: "memberProductId",
        },
        {
            Header: t("Status"),
            accessor: "status",
        },
        {
            Header: t("Amount"),
            accessor: "amount",
        },
        {
            Header: t("WinAmount"),
            accessor: "winAmount",
        },
        {
            Header: t("Date"),
            accessor: "date",
            Cell: ({ row }) => {
                return <>{moment(row.original.date).format("YYYY-MM-DD HH:mm:ss")}</>
            },
        },
        {
            Header: t("Remark"),
            accessor: "remark",
        },
        {
            Header: t("Turnover"),
            accessor: "turnover",
        },
        {
            Header: t("UpdatedTime"),
            accessor: "updatedTime",
            Cell: ({ row }) => {
                return <>{moment(row.original.updatedTime).format("YYYY-MM-DD HH:mm:ss")}</>
            },
        },
        {
            Header: t("PreMemberPrimaryBalance"),
            accessor: "preMemberPrimaryBalance",
        },
        {
            Header: t("PostMemberPrimaryBalance"),
            accessor: "postMemberPrimaryBalance",
        },
        {
            Header: t("LatestSyncRecordId"),
            accessor: "latestSyncRecordId",
        },
        {
            Header: t("PreSettleMemberPrimaryBalance"),
            accessor: "preSettleMemberPrimaryBalance",
        },
        {
            Header: t("PostSettleMemberPrimaryBalance"),
            accessor: "postSettleMemberPrimaryBalance",
        },
        {
            Header: t("IsCreditChange"),
            accessor: "isCreditChange",
            Cell: ({ row }) => {
                return row.original.isCreditChange ? <span className="badge badge-secondary badge-green">{t("YES")}</span> : <span className="badge badge-secondary badge-danger">{t("NO")}</span>
            },
        },
        {
            Header: t("SettlementAt"),
            accessor: "settlementAt",
        },
        {
            Header: t("BetIdParam_1"),
            accessor: "betIdParam_1",
        },
        {
            Header: t("Rollbacked"),
            accessor: "rollbacked",
        },
        {
            Header: t("IsJackpot"),
            accessor: "isJackpot",
            Cell: ({ row }) => {
                return row.original.isJackpot ? <span className="badge badge-secondary badge-green">{t("YES")}</span> : <span className="badge badge-secondary badge-danger">{t("NO")}</span>
            },
        },
        {
            Header: t("IsProcessed"),
            accessor: "isProcessed",
            Cell: ({ row }) => {
                return row.original.isProcessed ? <span className="badge badge-secondary badge-green">{t("YES")}</span> : <span className="badge badge-secondary badge-danger">{t("NO")}</span>
            },
        },
        {
            Header: t("ValidTurnover"),
            accessor: "validTurnover",
            Cell: ({ row }) => {
                return <>{(row.original.validTurnover).toFixed(3)}</>
            },
        }
    ];

    /// <summary>
    /// Author : -
    /// </summary>
    const handleEvent = (event, picker) => {
        setStartDate(moment(picker.startDate).format("YYYY-MM-DD"));
        setEndDate(moment(picker.endDate).format("YYYY-MM-DD"));
    };

    return (
        <div>
            <h1 className="page-header">{t("PROCESS_GAME_RECORD_REPORT")}</h1>
            <Panel>
                <PanelBody>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-4">
                                    <div
                                        className="form-group"
                                        style={{ display: "flex", width: "100%" }}
                                    >
                                        <div className="input-group" style={{ width: "100%" }}>
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className="fa fa-calendar"></i>
                                                </span>
                                            </div>
                                            <div style={{ width: "80%" }}>
                                                <DateRangePicker
                                                    containerStyles={{ width: "100%" }}
                                                    startDate={startDate}
                                                    endDate={endDate}
                                                    onApply={handleEvent}
                                                    alwaysShowCalendars={true}
                                                    locale={{ format: "YYYY-MM-DD" }}
                                                    ranges={{
                                                        Today: [moment(), moment()],
                                                        Yesterday: [
                                                            moment().subtract(1, "days"),
                                                            moment().subtract(1, "days"),
                                                        ],
                                                        "Last 7 Days": [
                                                            moment().subtract(6, "days"),
                                                            moment(),
                                                        ],
                                                        "Last 30 Days": [
                                                            moment().subtract(29, "days"),
                                                            moment(),
                                                        ],
                                                        "This Month": [
                                                            moment().startOf("month"),
                                                            moment().endOf("month"),
                                                        ],
                                                        "Last Month": [
                                                            moment().subtract(1, "month").startOf("month"),
                                                            moment().subtract(1, "month").endOf("month"),
                                                        ],
                                                    }}
                                                >
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={startDate + " - " + endDate}
                                                    />
                                                </DateRangePicker>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => getProcessReport()}
                                    >
                                        {t("SEARCH")}
                                    </button>
                                </div>
                            </div>
                            <hr />
                            <ReactTable data={processReportDatas} columns={_tableColumns} />
                        </div>
                    </div>
                </PanelBody>
            </Panel>
        </div>
    );
};

export default ProcessGameRecordReport;
